module.exports = __webpack_public_path__ + "static/img/slide-2-image@3x.159da8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo/slide-2-image@3x.jpg
// module id = SO7y
// module chunks = 6